import enOnly from './en-only'

export default {
  ...enOnly,
  nft: {
    traits: 'Đặc điểm',
    creator: 'Người tạo',
    tokenId: 'ID Token',
    contract: 'Hợp đồng',
    noNfts: 'Không tìm thấy NFT',
    notFound: 'Không tìm thấy NFT',
    description: 'Mô tả'
  },
  home: {
    stats: {
      injSupply: {
        marketCap: 'Vốn hóa thị trường',
        totalStaked: 'Tổng INJ đang stake',
        currentSupply: 'Nguồn cung INJ lưu hành',
        tooltipContent:
          '100% nguồn cung INJ hiện đang lưu hành. Nguồn cung lưu hành được báo cáo:'
      },
      transactions: {
        blockTime: 'Thời gian khối',
        blockHeight: 'Chiều cao khối',
        totalTransactions: 'Tổng số giao dịch'
      },
      assets: {
        tvl: 'Tổng giá trị tài sản',
        numberOfAssets: 'Số lượng tài sản',
        numberOfWallets: 'Số lượng ví'
      },
      staked: {
        apr: 'Tỷ lệ APR khi stake',
        total: 'Tổng số stake',
        injBurned: 'Số INJ đã bị đốt'
      }
    }
  },
  block: {
    table: {
      block: {
        proposer: 'Trình đề xuất',
        height: 'Chiều cao khối',
        timestamp: 'Dấu thời gian',
        'height-or-time': 'Chiều cao / Thời gian',
        transactions: 'Giao dịch',
        'proposer-or-txs': 'Trình đề xuất / Giao dịch'
      }
    },
    hash: 'Hash khối',
    proposer: 'Trình đề xuất',
    title: 'Chi tiết khối',
    height: 'Chiều cao khối',
    recentBlocks: 'Khối gần đây',
    updateBlocks: 'Cập nhật khối',
    notFoundDescription: 'Vui lòng thử lại.',
    invalidTitle: 'Định dạng khối không hợp lệ:',
    invalidDescription: 'Vui lòng nhập lại chiều cao khối chính xác.',
    notFoundTitle: 'Không thể tìm thấy khối này trên {network}:',
    stats: {
      blockTime: 'Thời gian khối',
      blockHeight: 'Chiều cao khối',
      blockCount: 'Số lượng khối (24 giờ qua)',
      transactions: 'Giao dịch (24 giờ qua)'
    }
  },
  assets: {
    table: {
      denomHolders: {
        value: 'Giá trị',
        address: 'Địa chỉ',
        quantity: 'Số lượng',
        percentage: 'Tỷ lệ'
      },
      smartContract: {
        token: 'Token',
        'contract-address': 'Địa chỉ hợp đồng'
      },
      assets: {
        token: 'Token',
        price: 'Giá',
        'total-usd-value': 'Giá trị USD',
        'current-supply': 'Nguồn cung hiện tại'
      }
    },
    name: 'Tên',
    type: 'Loại',
    denom: 'Denom',
    price: 'Giá',
    token: 'Token',
    value: 'Giá trị',
    admin: 'Quản trị viên',
    title: 'Tài sản',
    native: 'Gốc',
    decimal: 'Số thập phân',
    overview: 'Tổng quan',
    usdValue: 'Giá trị USD',
    allAssets: 'Tất cả tài sản',
    assetType: 'Loại tài sản',
    assetDetail: 'Chi tiết tài sản',
    totalAssets: 'Tổng tài sản',
    searchToken: 'Tìm kiếm token',
    currentSupply: 'Nguồn cung hiện tại',
    insuranceFund: 'Quỹ bảo hiểm',
    smartContracts: 'Hợp đồng thông minh',
    adapterAddress: 'Địa chỉ Adapter',
    creatorAddress: 'Địa chỉ người tạo',
    contractAddress: 'Địa chỉ hợp đồng',
    submitTokenInfo: 'Gửi thông tin token',
    totalAssetValue: 'Tổng giá trị tài sản',
    tokenVerification: 'Xác minh token',
    assetsOnInj: 'Tài sản trên chuỗi Injective',
    includeUnknownTokens: 'Bao gồm token không rõ nguồn gốc',
    stakedAssetValue: 'Giá trị tài sản đang stake (INJ)',
    totalOnchainAssets: 'Tổng tài sản on-chain',
    submitTokenMetadata: 'Gửi metadata token',
    assetsOnSmartContracts: 'Tài sản trên hợp đồng thông minh',
    currentSupplyTimesPrice: 'Nguồn cung hiện tại nhân giá',
    adminNote: 'Địa chỉ người phát hành có thể tăng nguồn cung',
    tokensOnInjective: 'Số lượng token đang lưu hành trên Injective',
    theAmountDisplayedMayNotBeInTheCorrectScale:
      'Số lượng hiển thị có thể không đúng tỉ lệ',
    theInfoOfTokenExternalVerification:
      'Tên token này dựa trên thông tin tìm thấy trên mạng lưới gốc của nó.',
    toast: {
      assetNotFound: 'Không tìm thấy tài sản với denom {denom}'
    },
    tabs: {
      assets: 'Token',
      'assets-smart-contracts': 'Hợp đồng thông minh'
    },
    stakingTabs: {
      'account-account-staking': 'Đang stake',
      'account-account-staking-unstake': 'Đang gỡ stake',
      'account-account-staking-restake': 'Tái stake'
    },
    denomHolders: {
      title: 'Người nắm giữ',
      value: 'Giá trị',
      address: 'Địa chỉ',
      percentage: 'Phần trăm',
      quantity: 'Số lượng'
    }
  },
  wallet: {
    beta: 'Beta',
    wallet: 'Ví',
    popular: 'Phổ biến',
    address: 'Địa chỉ',
    connect: 'Kết nối',
    overview: 'Tổng quan',
    connected: 'Đã kết nối',
    disconnect: 'Ngắt kết nối',
    otherWallets: 'Ví khác',
    connectWallet: 'Kết nối ví',
    connectAWallet: 'Kết nối một ví',
    connectedWallet: 'Ví đã kết nối',
    disconnectWallet: 'Ngắt kết nối ví',
    connectUsingTorus: 'Đăng nhập một lần nhấp bằng',
    successfullyConnected: 'Kết nối thành công',
    connectUsingBrowser: 'Kết nối bằng ví trình duyệt',
    connectUsingHardware: 'Kết nối bằng ví phần cứng',
    connectWalletToUseNotifications: 'Kết nối ví của bạn để sử dụng thông báo',
    hardwareWallet: {
      getAddresses: 'Lấy địa chỉ',
      getMoreAddresses: 'Lấy thêm địa chỉ',
      selectAddressToConnect: 'Chọn địa chỉ để kết nối',
      getAddressNote: 'Đang lấy địa chỉ của bạn, vui lòng chờ...'
    },
    trezor: {
      trezor: 'Trezor',
      trezorBip32: 'Trezor',
      trezorBip44: 'Trezor Bip44',
      derivationPath: 'Đường dẫn dẫn xuất',
      selectDerivationPath: 'Chọn đường dẫn dẫn xuất',
      note: 'Lưu ý: Để đảm bảo quá trình kết nối ví phần cứng Trezor diễn ra suôn sẻ, hãy đảm bảo bạn đang sử dụng phiên bản Chrome mới nhất, và thiết bị Trezor của bạn đã được kết nối và mở khóa.'
    },
    ledger: {
      ledgerLive: 'Ledger Live',
      ledgerLegacy: 'Ledger Legacy',
      derivationPath: 'Đường dẫn dẫn xuất',
      selectDerivationPath: 'Chọn đường dẫn dẫn xuất',
      note: 'Lưu ý: Để đảm bảo quá trình kết nối ví phần cứng Ledger diễn ra suôn sẻ, hãy đảm bảo bạn đang sử dụng phiên bản Chrome mới nhất, thiết bị Ledger đã được kết nối, mở khóa và ứng dụng Ethereum đã được mở.'
    }
  },
  account: {
    table: {
      staked: {
        reward: 'Phần thưởng',
        amount: 'Số lượng',
        validator: 'Trình xác thực'
      },
      restaking: {
        amount: 'Số lượng',
        'destination-validator': 'Trình xác thực đích',
        'source-validator': 'Trình xác thực nguồn',
        'completition-time': 'Thời gian hoàn tất'
      },
      unstaking: {
        amount: 'Số lượng',
        validator: 'Trình xác thực',
        'completition-time': 'Thời gian hoàn tất'
      },
      balances: {
        price: 'Giá',
        amount: 'Số lượng',
        holding: 'Đang giữ',
        'usd-value': 'Giá trị USD',
        'unrealized-pnl': 'Lãi/lỗ chưa thực hiện',
        'in-use-reserved': 'Đang dùng/Dự phòng',
        'available-balance': 'Số dư khả dụng'
      },
      cw20Balances: {
        balance: 'Số dư',
        holding: 'Đang giữ',
        'contract-address': 'Địa chỉ hợp đồng'
      }
    },
    cw20: 'CW',
    ibc: 'IBC',
    bank: 'Ngân hàng',
    total: 'Tổng cộng',
    value: 'Giá trị',
    amount: 'Số lượng',
    native: 'Gốc',
    price: 'Giá',
    staked: 'Đang stake',
    tokens: 'Token',
    reward: 'Phần thưởng',
    address: 'Địa chỉ',
    balance: 'Số dư',
    holding: 'Đang giữ',
    unknown: 'Không xác định',
    unstake: 'Gỡ stake',
    restake: 'Tái stake',
    balances: 'Số dư',
    cosmwasm: 'CosmWasm',
    holdings: 'Khoản giữ',
    usdValue: 'Giá trị USD',
    validator: 'Trình xác thực',
    allAssets: 'Tất cả tài sản',
    assetType: 'Loại tài sản',
    unbondings: 'Gỡ bỏ liên kết',
    injBalance: 'Số dư INJ',
    totalValue: 'Tổng giá trị',
    details: 'Chi tiết địa chỉ',
    delegations: 'Ủy quyền',
    bridgedERC20: 'ERC20 đã cầu nối',
    cw20Balances: 'Số dư CW20',
    pathToOrigin: 'Đường dẫn gốc',
    insuranceFund: 'Quỹ bảo hiểm',
    unrealizedPnl: 'Lãi/lỗ chưa thực hiện',
    inUseReserved: 'Đang dùng/Dự phòng',
    tradingAccount: 'Tài khoản giao dịch',
    unknownNetwork: 'Mạng không xác định',
    contractAddress: 'Địa chỉ hợp đồng',
    sourceValidator: 'Trình xác thực nguồn',
    totalInjBalance: 'Tổng số dư INJ',
    whatDoesItMean: 'Điều đó có nghĩa là gì?',
    availableBalance: 'Số dư khả dụng',
    claimableRewards: 'Phần thưởng có thể nhận',
    completitionTime: 'Thời gian hoàn tất',
    notFoundDescription: 'Vui lòng thử lại.',
    latestTransactions: 'Giao dịch gần đây',
    noUnstakingFound: 'Không có tài sản đang gỡ stake.',
    insuranceFundToken: 'Token quỹ bảo hiểm',
    noStakedFound: 'Không có tài sản đã stake.',
    destinationValidator: 'Trình xác thực đích',
    noTransactionsFound: 'Không tìm thấy giao dịch.',
    noRestakingFound: 'Không có tài sản đang tái stake.',
    tradingAccountBalances: 'Số dư tài khoản giao dịch',
    isBalanceBreakdownEnabled: 'Bao gồm phân tích số dư',
    invalidDescription: 'Vui lòng nhập lại địa chỉ tài khoản chính xác.',
    invalidTitle: 'Định dạng địa chỉ tài khoản sau không hợp lệ:',
    notFoundTitle: 'Không thể tìm thấy tài khoản này trên {network}:',
    ibcAssetPathDisplay:
      'Tài sản IBC có cách hiển thị riêng về nguồn gốc và đường chuyển.',
    amountIncludes:
      'Số lượng bao gồm Ký quỹ và Lãi/lỗ chưa thực hiện từ vị thế mở cũng như đơn hàng mở.',
    totalValueIncludes:
      'Tổng giá trị bao gồm Ký quỹ và Lãi/lỗ chưa thực hiện từ vị thế mở, đơn hàng mở và số lượng stake. Lưu ý rằng dữ liệu vị thế và PnL được tải lên ở nền.',
    verified: 'Đã xác minh',
    internalVerification: 'Đã xác minh nội bộ',
    externalVerification: 'Đã xác minh bên ngoài',
    unverified: 'Chưa xác minh',
    tokenFactory: 'Trình tạo Token',
    tabs: {
      'account-account-index': 'Số dư',
      'account-account-transactions': 'Giao dịch',
      'account-account-staking': 'Staking',
      'account-account-nft': 'NFTs'
    },
    balanceTabs: {
      'account-account-index': 'Injective',
      'account-account-index-cw20': 'CW20'
    }
  },
  markets: {
    table: {
      fundingRate: {
        time: 'Thời gian',
        'funding-rate': 'Tỷ lệ tài trợ',
        'funding-interval': 'Chu kỳ tài trợ'
      },
      realTimeFundingRate: {
        markets: 'Thị trường',
        'next-funding': 'Lần tài trợ tiếp theo',
        'hourly-interest-rate': 'Lãi suất theo giờ',
        'estimated-funding-rate': 'Tỷ lệ tài trợ ước tính'
      },
      tradingRules: {
        markets: 'Thị trường',
        'min-notional': 'Giá trị danh nghĩa tối thiểu',
        'base-maker-fee': 'Phí tạo lệnh cơ bản',
        'base-taker-fee': 'Phí khớp lệnh cơ bản',
        'min-price-movement': 'Biến động giá tối thiểu',
        'min-amount-movement': 'Biến động khối lượng tối thiểu',
        'initial-margin-ratio': 'Tỷ lệ ký quỹ ban đầu',
        'maintenance-margin-ratio': 'Tỷ lệ ký quỹ duy trì'
      },
      marketInfo: {
        type: 'Loại',
        price: 'Giá',
        markets: 'Thị trường',
        volume: 'Khối lượng (24h)',
        'volume-in-usd': 'Khối lượng (24h) theo USD'
      }
    },
    allMarkets: 'Tất cả thị trường',
    allTypes: 'Tất cả loại',
    baseDenom: 'Đơn vị cơ bản',
    baseMakerFee: 'Phí tạo lệnh cơ bản',
    baseTakerFee: 'Phí khớp lệnh cơ bản',
    derivative: 'Phái sinh',
    estimatedFundingRate: 'Tỷ lệ tài trợ ước tính',
    exchangeRelayers: 'Sàn giao dịch / Bộ chuyển tiếp',
    fundingInterval: 'Chu kỳ tài trợ',
    fundingRate: 'Tỷ lệ tài trợ',
    hourlyInterestRate: 'Lãi suất theo giờ',
    includeLowVolumeMarkets: 'Bao gồm thị trường khối lượng thấp',
    initialMarginRatio: 'Tỷ lệ ký quỹ ban đầu',
    lastFundingRate: 'Tỷ lệ tài trợ gần nhất',
    lastTwelveHours: '12 giờ qua',
    lastTwentyFourHours: '24 giờ qua',
    maintenanceMarginRatio: 'Tỷ lệ ký quỹ duy trì',
    minNotional: 'Giá trị danh nghĩa tối thiểu',
    makerFeeRate: 'Tỷ lệ phí tạo lệnh',
    market: 'Thị trường',
    marketId: 'ID thị trường',
    marketsInfo: 'Thông tin thị trường',
    marketDetails: 'Chi tiết thị trường',
    tabs: {
      markets: 'Thông tin thị trường',
      'markets-realtime-funding-rate': 'Tỷ lệ tài trợ thời gian thực',
      'markets-funding-rate-history': 'Lịch sử tỷ lệ tài trợ',
      'markets-trading-rules': 'Quy tắc giao dịch'
    },
    marketType: 'Loại thị trường',
    minAmountMovement: 'Biến động khối lượng tối thiểu',
    minPriceMovement: 'Biến động giá tối thiểu',
    minPriceTickSize: 'Bước giá tối thiểu',
    minQuantityTickSize: 'Bước khối lượng tối thiểu',
    nextFunding: 'Lần tài trợ tiếp theo',
    oracleBase: 'Giá cơ sở từ Oracle',
    oracleQuote: 'Giá báo từ Oracle',
    oracleType: 'Loại Oracle',
    oracleScaleFactor: 'Hệ số quy mô Oracle',
    perDay: 'mỗi ngày',
    price: 'Giá',
    proposalId: 'ID đề xuất',
    quoteDenom: 'Đơn vị báo giá',
    searchMarket: 'Tìm kiếm thị trường',
    spot: 'Giao ngay',
    takerFeeRate: 'Tỷ lệ phí khớp lệnh',
    ticker: 'Mã giao dịch',
    time: 'Thời gian',
    type: 'Loại',
    usd: 'USD',
    volume: 'Khối lượng (24h)',
    volumeInUsd: 'Khối lượng (24h) theo USD',
    oneHour: '1 giờ',
    futures: 'Hợp đồng tương lai',
    toast: {
      notFound: 'Không thể lấy thị trường với ID {id}'
    }
  },
  spendPool: {
    table: {
      to: 'Đến',
      from: 'Từ',
      amount: 'Số lượng',
      timestamp: 'Dấu thời gian',
      'block-height': 'Chiều cao khối'
    },
    title: 'Quỹ chi tiêu cộng đồng / Mô-đun phân phối',
    to: 'Đến CSP',
    from: 'Từ CSP/DM',
    enterAddress: 'Nhập địa chỉ',
    timeRange: 'Chọn khoảng thời gian',
    communitySpendPool: 'Quỹ chi tiêu cộng đồng',
    cspDistributionModule: 'CSP / Mô-đun phân phối',
    enterAddressToSeeResults: 'Vui lòng nhập địa chỉ Injective để xem kết quả'
  },
  transaction: {
    table: {
      transactions: {
        type: 'Loại',
        time: 'Thời gian',
        block: 'Khối',
        status: 'Trạng thái',
        amount: 'Số lượng',
        'txn-hash': 'Mã băm giao dịch',
        'tx-hash-and-type': 'Mã băm giao dịch / Loại',
        'status-and-amount': 'Trạng thái / Số lượng'
      }
    },
    txs: 'Giao dịch',
    fee: 'Phí',
    type: 'Loại',
    hash: 'Mã băm',
    time: 'Thời gian',
    memo: 'Ghi chú',
    view: 'Xem',
    items: 'Mục',
    height: 'Chiều cao',
    events: 'Sự kiện',
    sender: 'Người gửi',
    newTxs: 'Giao dịch mới',
    txHash: 'Mã băm giao dịch',
    message: 'Tin nhắn',
    summary: 'Tóm tắt',
    txnHash: 'Mã băm giao dịch',
    messages: 'Tin nhắn',
    errorLog: 'Nhật ký lỗi',
    exportCsv: 'Xuất CSV',
    messageType: 'Loại tin nhắn',
    tokenTransfers: 'Chuyển token',
    defiActivities: 'Hoạt động DeFi',
    rawTransaction: 'Giao dịch thô',
    transactionHash: 'Mã băm giao dịch',
    updateTransactions: 'Cập nhật giao dịch',
    transactionDetails: 'Chi tiết giao dịch',
    gasUsedAndRequested: 'Gas (Đã dùng / Yêu cầu)',
    noTransactionsFound: 'Không tìm thấy giao dịch nào.',
    filter: {
      types: 'Các loại',
      reset: 'Đặt lại',
      filters: 'Bộ lọc',
      allTypes: 'Tất cả loại',
      messageType: 'Loại tin nhắn',
      selectAll: 'Chọn tất cả',
      clearAll: 'Xóa tất cả',
      resetMessages: 'Đặt lại tin nhắn'
    },
    stats: {
      totalTransactions: 'Tổng số giao dịch',
      transactionsThirtyDays: 'Giao dịch (30 ngày)',
      transactionsLast24Hours: 'Giao dịch (24 giờ qua)',
      tps: 'TPS (100 khối gần nhất)'
    },
    voter: 'Người bỏ phiếu',
    signer: 'Người ký',
    details: 'Chi tiết',
    proposer: 'Người đề xuất',
    receiver: 'Người nhận',
    depositor: 'Người gửi tiền',
    validator: 'Trình xác thực',
    subaccount: 'Tài khoản phụ',
    orchestrator: 'Người điều phối',
    hashInvalidTitle: 'Rất tiếc! Mã băm giao dịch không hợp lệ đã được nhập:',
    hashInvalidDescription: 'Vui lòng nhập lại mã băm giao dịch chính xác.',
    notFoundTitle: 'Rất tiếc, không tìm thấy giao dịch sau trên {network}',
    notFoundDescription:
      'Injective Explorer chỉ cung cấp tổng quan về trạng thái hiện tại của blockchain như trạng thái giao dịch của bạn. Injective Explorer KHÔNG kiểm soát bất kỳ giao dịch nào.',
    notFoundDescriptionPoint1:
      '1) Nếu bạn vừa gửi một giao dịch, hãy đợi ít nhất 30 giây trước khi làm mới trang này.',
    notFoundDescriptionPoint2:
      '2) Giao dịch của bạn có thể vẫn đang ở trong bộ nhớ TX của một node khác, chờ được phát sóng.',
    notFoundDescriptionPoint3:
      '3) Nếu mạng đang bận, có thể mất một khoảng thời gian để giao dịch của bạn hiển thị.',
    notFoundDescriptionPoint4:
      '4) Nếu giao dịch vẫn chưa xuất hiện sau 1 giờ, hãy kiểm tra lại với người gửi, sàn giao dịch, ví hoặc nhà cung cấp dịch vụ giao dịch của bạn.',
    proposal: {
      proposal: 'đề xuất',
      yes: 'đồng ý',
      abstain: 'bỏ phiếu trắng',
      no: 'không đồng ý',
      noWithVeto: 'không đồng ý và phủ quyết'
    },
    summaryType: {
      MsgExecuteContractCompatSwap:
        '{sender} hoán đổi {inputAmount} {inputSymbol} lấy {outputAmount} {outputSymbol}'
    },
    eventLogs: {
      title: 'Nhật ký sự kiện',
      logs: 'nhật ký'
    },
    claimId: 'Yêu cầu #',
    claimIdNote:
      'Nhiều giao dịch MsgDepositClaim được thực hiện cho một khoản nạp Ethereum. Mỗi khoản nạp được xác định bởi một claimId duy nhất.',
    generatingCsvSuccessMessage: 'Tạo file CSV thành công!',
    generatingCsvErrorMessage: 'Gặp sự cố khi tạo file CSV. Vui lòng thử lại.'
  },
  tradeHistory: {
    table: {
      tradeHistory: {
        time: 'Thời gian',
        type: 'Loại',
        side: 'Bên giao dịch',
        amount: 'Số lượng',
        market: 'Thị trường',
        address: 'Địa chỉ',
        'trade-id': 'ID giao dịch'
      }
    },
    buy: 'Mua',
    fee: 'Phí',
    time: 'Thời gian',
    type: 'Loại',
    long: 'Dài',
    side: 'Bên giao dịch',
    sell: 'Bán',
    short: 'Ngắn',
    event: 'Sự kiện',
    filter: 'Bộ lọc',
    payout: 'Thanh toán',
    market: 'Thị trường',
    amount: 'Số lượng',
    address: 'Địa chỉ',
    tradeId: 'ID giao dịch',
    timestamp: 'Dấu thời gian',
    spotTrade: 'Giao dịch Spot',
    timeRange: 'Khoảng thời gian',
    allMarkets: 'Tất cả thị trường',
    blockHeight: 'Chiều cao khối',
    tradeActivity: 'Hoạt động giao dịch',
    tradeIdDetails: 'Chi tiết ID giao dịch',
    tradingActivity: 'Hoạt động giao dịch',
    tradeHistoryDaily: 'Hoạt động giao dịch (24h)',
    clearFilters: 'Xóa bộ lọc',
    feeRecipient: 'Người nhận phí',
    subaccountId: 'ID tài khoản phụ',
    derivativeTrade: 'Giao dịch phái sinh',
    filterByAddress: 'Lọc theo địa chỉ',
    tradeHistoryDetails: 'Chi tiết lịch sử giao dịch',
    toast: {
      notFound: 'Không thể tìm giao dịch với ID {id}'
    },
    tabs: {
      'trade-history-spot': 'Giao ngay',
      'trade-history-derivatives': 'Phái sinh'
    }
  },
  smartContracts: {
    table: {
      smartContracts: {
        'tx-hash': 'Mã băm giao dịch',
        address: 'Địa chỉ',
        creator: 'Người tạo',
        executed: 'Đã thực thi',
        'last-executed-or-created': 'Lần thực thi/Tạo gần nhất',
        'contract-name-or-type': 'Tên hợp đồng/Loại'
      },
      wasm: {
        'tx-hash': 'Mã băm giao dịch',
        creator: 'Người tạo',
        version: 'Phiên bản',
        'id-or-type': 'ID/Loại',
        instances: 'Số phiên bản',
        'creation-date': 'Ngày tạo'
      },
      tokenHolders: {
        address: 'Địa chỉ',
        balance: 'Số dư'
      }
    },
    tabs: {
      'smart-contracts': 'Hợp đồng',
      'smart-contracts-code': 'Mã'
    },
    contract: {
      fee: 'Phí',
      time: 'Thời gian',
      type: 'Loại',
      admin: 'Quản trị viên',
      denom: 'Đơn vị',
      funds: 'Quỹ',
      amount: 'Số lượng',
      height: 'Chiều cao khối',
      result: 'Kết quả',
      codeId: 'ID mã',
      txHash: 'Mã băm giao dịch',
      address: 'Địa chỉ',
      balance: 'Số dư',
      created: 'Đã tạo',
      creator: 'Người tạo',
      decimal: 'Số thập phân',
      initMsg: 'Tin nhắn khởi tạo',
      cosmwasm: 'CosmWasm',
      balances: 'Số dư',
      contract: 'Hợp đồng',
      executed: 'Đã thực thi',
      tokenInfo: 'Thông tin token',
      tokenHolders: 'Người nắm giữ token',
      noInitMsg: 'Không có tin nhắn khởi tạo',
      contractName: 'Tên hợp đồng',
      creationDate: 'Ngày tạo',
      lastExecuted: 'Lần thực thi gần nhất',
      smartContract: 'Hợp đồng thông minh',
      smartContracts: 'Hợp đồng thông minh',
      lastExecutedAt: 'Thời gian thực thi gần nhất',
      searchContracts: 'Tìm kiếm hợp đồng',
      updateContracts: 'Cập nhật hợp đồng',
      notFoundDescription: 'Vui lòng thử lại.',
      smartContractDetails: 'Chi tiết hợp đồng thông minh',
      invalidTitle: 'Rất tiếc! Định dạng địa chỉ hợp đồng sau không hợp lệ:',
      invalidDescription: 'Vui lòng nhập lại địa chỉ hợp đồng chính xác.',
      notFoundTitle:
        'Rất tiếc, chúng tôi không thể tìm thấy hợp đồng này trên {network}:',
      queryAndExecute: {
        max: 'Tối đa',
        copy: 'Sao chép',
        query: 'Truy vấn',
        search: 'Tìm kiếm',
        execute: 'Thực thi',
        balance: 'Số dư:',
        queryMsg: 'Tin nhắn truy vấn',
        title: 'Truy vấn / Thực thi',
        jsonInput: 'Nhập JSON',
        executeMsg: 'Tin nhắn thực thi',
        formatJSON: 'Định dạng JSON',
        queryResult: 'Kết quả truy vấn',
        attachFunds: 'Đính kèm quỹ',
        selectAsset: 'Chọn tài sản',
        enterAmount: 'Nhập số lượng',
        addMoreAssets: 'Thêm tài sản khác',
        suggestions: 'Gợi ý tin nhắn',
        viewTransaction: 'Xem giao dịch',
        successfullyCopied: 'Đã sao chép thành công',
        successfullyExecuted: 'Thực thi thành công',
        connectToExecute: 'Kết nối ví để thực thi hợp đồng',
        wallet: {
          connectWallet: 'Kết nối ví'
        },
        tabs: {
          'contract-contract-action': 'Truy vấn',
          'contract-contract-action-execute': 'Thực thi'
        }
      }
    },
    code: {
      id: 'ID',
      type: 'Loại',
      idType: 'ID/Loại',
      codeId: 'ID mã',
      txHash: 'Mã băm giao dịch',
      creator: 'Người tạo',
      version: 'Phiên bản',
      checksum: 'Mã kiểm tra',
      contract: 'Hợp đồng',
      wasmCode: 'Mã Wasm',
      instances: 'Phiên bản',
      wasmCodes: 'Mã Wasm',
      permission: 'Quyền hạn',
      codeDetail: 'Chi tiết mã',
      codeSchema: 'Lược đồ mã',
      codeViewer: 'Trình xem mã',
      proposalId: 'ID đề xuất',
      updateCodes: 'Cập nhật mã',
      creationDate: 'Ngày tạo',
      wasmCodeDetails: 'Chi tiết mã Wasm',
      permittedAddress: 'Địa chỉ được phép',
      notFoundDescription: 'Vui lòng thử lại.',
      invalidTitle: 'Rất tiếc! Định dạng ID mã sau không hợp lệ:',
      invalidDescription: 'Vui lòng nhập lại ID mã chính xác.',
      notFoundTitle:
        'Rất tiếc, chúng tôi không thể tìm thấy mã này trên {network}:'
    }
  },
  common: {
    via: 'thông qua',
    code: 'Mã',
    back: 'Quay lại',
    sent: 'đã gửi',
    type: 'Loại',
    dApps: 'DApps',
    block: 'Khối',
    fail: 'Thất bại',
    amount: 'Số lượng',
    assets: 'Tài sản',
    blocks: 'Các khối',
    wasmCode: 'Mã',
    status: 'Trạng thái',
    failed: 'Thất bại',
    inputs: 'Dữ liệu vào',
    update: 'Cập nhật',
    details: 'Chi tiết',
    outputs: 'Dữ liệu ra',
    account: 'Tài khoản',
    success: 'Thành công',
    markets: 'Thị trường',
    chainId: 'ID chuỗi',
    viewAll: 'Xem tất cả',
    overview: 'Tổng quan',
    received: 'đã nhận',
    contracts: 'Hợp đồng',
    search: 'Tìm kiếm',
    time: 'Thời gian',
    timestamp: 'Dấu thời gian',
    transaction: 'Giao dịch',
    transactions: 'Giao dịch',
    analytics: 'Phân tích',
    activity: 'Hoạt động',
    all: 'Tất cả',
    from: 'Từ',
    to: 'Đến',
    cosmWasm: 'CosmWasm',
    rawJson: 'JSON gốc',
    noItems: 'Không có mục nào.'
  },
  navigation: {
    hub: 'Hub',
    network: 'Mạng lưới',
    trading: 'Giao dịch',
    ecosystem: 'Hệ sinh thái',
    validators: 'Trình xác thực',
    developers: 'Nhà phát triển'
  },
  network: {
    terra: 'Terra',
    evmos: 'Evmos',
    axelar: 'Axelar',
    cosmos: 'Cosmos',
    osmosis: 'Osmosis',
    ethereum: 'Ethereum',
    chihuahua: 'ChiHuaHua',
    persistence: 'Persistence',
    injective: 'Injective Chain',
    mainnet: 'Mainnet',
    testnet: 'Testnet'
  },
  toast: {
    codeIdCopied: 'ID mã đã được sao chép vào clipboard',
    addressCopied: 'Địa chỉ đã được sao chép vào clipboard',
    tradeIdCopied: 'ID giao dịch đã được sao chép vào clipboard',
    marketIdCopied: 'ID thị trường đã được sao chép vào clipboard',
    denomHashCopied: 'Hash đơn vị đã được sao chép vào clipboard',
    txHashCopied: 'Hash giao dịch đã được sao chép vào clipboard',
    blockNumberCopied: 'Chiều cao khối đã được sao chép vào clipboard',
    contractCopied: 'Địa chỉ hợp đồng đã được sao chép vào clipboard',
    contractInitMsgCopied: 'Tin nhắn khởi tạo hợp đồng đã được sao chép',
    contractFundCopied: 'Chi tiết quỹ hợp đồng đã được sao chép',
    contractTokenInfoCopied: 'Thông tin token hợp đồng đã được sao chép'
  },
  networkError: {
    accountPageBankBalances: 'Lỗi mạng: Không thể lấy số dư.',
    accountPageCW20Balances: 'Lỗi mạng: Không thể lấy số dư.',
    accountPageSubaccountBalances: 'Lỗi mạng: Không thể lấy số dư.',
    accountPageTransactions: 'Lỗi mạng: Không thể lấy giao dịch.',
    blockDetailsPage: 'Lỗi mạng: Không thể lấy thông tin khối.',
    blocksPageBlocks: 'Lỗi mạng: Không thể lấy các khối.',
    contractDetailsPage: 'Lỗi mạng: Không thể lấy hợp đồng.',
    contractsPageContracts: 'Lỗi mạng: Không thể lấy hợp đồng.',
    contractsPageAccountsBalance:
      'Lỗi mạng: Không thể lấy danh sách người giữ token.',
    contractPageTransactions: 'Lỗi mạng: Không thể lấy giao dịch.',
    transactionDetailsPage: 'Lỗi mạng: Không thể lấy giao dịch.',
    transactionsPageTransactions: 'Lỗi mạng: Không thể lấy giao dịch.',
    wasmCodePageCodes: 'Lỗi mạng: Không thể lấy mã.',
    wasmCodeDetailsPage: 'Lỗi mạng: Không thể lấy mã.',
    communitySpendPool: 'Lỗi mạng: Không thể lấy giao dịch.',
    denomHolders: 'Lỗi mạng: Không thể lấy danh sách người giữ token.'
  },
  noRecord: {
    accountPageBankBalances: 'Không tìm thấy số dư.',
    accountPageCW20Balances: 'Không tìm thấy số dư.',
    accountPageSubaccountBalances: 'Không tìm thấy số dư.',
    accountPageTransactions: 'Không tìm thấy giao dịch.',
    blocksPageBlocks: 'Không tìm thấy khối nào.',
    contractsPageContracts: 'Không tìm thấy hợp đồng thông minh nào.',
    contractsPageAccountsBalance: 'Không tìm thấy người giữ token.',
    genericNoRecordsFound: 'Không tìm thấy dữ liệu.',
    tradeHistory: 'Không thể lấy lịch sử giao dịch.',
    transactionsPageTransactions: 'Không tìm thấy giao dịch nào.',
    wasmCodePageCodes: 'Các hợp đồng sẽ ra mắt sớm!',
    communitySpendPool: 'Không tìm thấy kết quả.',
    denomHolders: 'Không tìm thấy người giữ token.',
    noResultsFound: 'Không có kết quả cho {search}'
  },
  pagination: {
    showRows: 'Hiển thị dòng'
  },
  FilterClearFilterBtn: 'Xóa bộ lọc',
  FilterApplyBtn: 'Lọc',
  notFound: '404 Không tìm thấy',
  searchPlaceHolder: 'Tìm kiếm giao dịch, khối hoặc địa chỉ',
  FooterCopyRightMsg:
    'Bản quyền © {year} Injective Foundation. Đã đăng ký mọi quyền.',
  maintenance: {
    title: 'Bảo trì theo lịch trình',
    description:
      'Chúng tôi đang thực hiện một số cập nhật mới. Trong thời gian này, một số tính năng sẽ tạm thời không khả dụng.',
    governance: 'Đề xuất quản trị',
    governanceDescription: 'Xem chi tiết về bản nâng cấp chuỗi mới nhất',
    subscribe: 'Đăng ký nhận cảnh báo',
    subscribeDescription: 'Nhận thông báo thời gian thực qua Notifi',
    footer:
      'Chúng tôi đang cải thiện InjScan. Cảm ơn sự kiên nhẫn của bạn và chúng tôi sẽ sớm trở lại!'
  },
  bgLoadingNote:
    'Để cải thiện trải nghiệm, chúng tôi đang tải dữ liệu bên ngoài ở chế độ nền.',
  notFound404: {
    title: 'Không tìm thấy trang',
    description: 'Trang bạn đang tìm kiếm không tồn tại.',
    backToHome: 'Quay lại trang chủ'
  },
  injNameDoesNotExist:
    '{injName} không tồn tại. Bạn có thể đăng ký nó tại {link}',
  banners: {
    findOutMore: 'Tìm hiểu thêm'
  }
}
